<div class="avatars-block">
	<div class="ava-block" *ngFor="let ava of avaArr">
		<div class="word-avatar" style.background-color="#{{ava.bgColor}}">
			<div class="short-name">
				{{ava.shortCode}}
			</div>
		</div>
	</div>
</div>